import { memo, useCallback } from 'react'
import Box from '@mui/material/Box'
import { useParams } from 'react-router-dom'
import { ChipResetFilter } from '../../../../shared/ui/ChipResetFilter/ChipResetFilter'
import {
	useAppDispatch
} from '../../../../shared/lib/hooks/useAppDispatch/useAppDispatch'
import {
	useAppSelector
} from '../../../../shared/lib/hooks/useAppSelector/useAppSelector'
import { selectQueryFilters } from '../../model/selectors/selectFilters'
import { licenseEventsActions } from '../../model/slices/licenseEventsSlice'
import { fetchLicenseEvents } from '../../model/services/fetchLicenseEvents'
import { LicenseEventsFilterChip } from './LicenseEventsFilterChip'
import { isISOString } from '../../../../shared/lib/DateAndTieHelpers/isISOString'
import {
	formatISOToReadable
} from '../../../../shared/lib/DateAndTieHelpers/fromISOToReadable'

interface LicenseEventsFilterChipListProps {
	licenseId: string
}

export const LicenseEventsFilterChipList = memo(
	function LicenseEventsFilterChipList(props: LicenseEventsFilterChipListProps) {
		const { licenseId } = props
		const dispatch = useAppDispatch()
		const { licenseId: licIdFromParams } = useParams()

		const filters = useAppSelector(selectQueryFilters)
		const activeFilters = Object.entries(filters).filter(([_, filterValue]) => filterValue)
		const activeFiltersLen = activeFilters.length

		const handleReset = useCallback(() => {
			dispatch(licenseEventsActions.resetFilter())
			dispatch(licenseEventsActions.setPage(1))
			dispatch(fetchLicenseEvents(licIdFromParams ?? licenseId))
		}, [dispatch, licIdFromParams, licenseId])

		return (
			<>
				{!!activeFiltersLen && (
					<Box sx={{
						marginBottom: '1.5rem',
						display: 'flex',
						gap: 1,
						flexWrap: 'wrap'
					}}>
						<ChipResetFilter handleReset={handleReset} />
						{activeFilters.map(([filterKey, filterValue]) => (
							<LicenseEventsFilterChip
								key={filterKey + filterValue}
								filterKey={filterKey}
								filterValue={isISOString(filterValue)
									? formatISOToReadable(filterValue)
									: filterValue as string
								}
								licenseId={licenseId}
							/>
						))}
					</Box>
				)}
			</>
		)
	})
